export default function GS_Absolute_Reference() {
  return (
    <div className="p-4">
      <h1>GS Absolute Reference</h1>
    </div>
  );
}
